// extracted by mini-css-extract-plugin
export default {"border":"style_border__EhvGH","bg":"style_bg__BEDZa","txt1":"style_txt1__fFIf8","txt2":"style_txt2__Re99L","enableIcon":"style_enableIcon__vt5h0"};